import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  changeStatus, runSchedule,
  clearError,
  sortBySchedulers
} from 'store/Schedule/actions';
import {
  selectIsFetching, selectData, selectFields, selectSchedulersSelected,
  selectError,
  selectErrorMessage
} from 'store/Schedule/selectors';
import { MODAL_SCHEDULER_INACTIVE_WARNING, MODAL_SCHEDULER_NO_WS_WARNING, MODAL_SCHEDULER_OFFLINE_AGENT_WARNING } from 'store/modals/modals';
import { openModal } from 'store/modals/actions';
import scheduledAgentsSchema from 'Screens/Automation/Schedule/components/ScheduledAgents/schema';
import { TableWrapper } from '../../styled';
import EmptySchedule from '../EmptySchedule';
import SharedTable from 'shared/ui/Table';
import ErrorDialog from 'Common/Components/ErrorDialog';

const ScheduledAgents = () => {
  const section = 'scheduledAgents';
  const dispatch = useDispatch();
  const fields = useSelector((state) => selectFields(state, section));
  const isFetching = useSelector((state) => selectIsFetching(state, section));
  const data = useSelector((state) => selectData(state, section));
  const schedulersSelected = useSelector(selectSchedulersSelected);
  const error = useSelector((state) => selectError(state, section));
  const errorMessage = useSelector((state) => selectErrorMessage(state, section));

  const noDataText = isFetching ? '' : <EmptySchedule />;

  const fetchData = (sorted) => !isFetching && dispatch(sortBySchedulers(sorted));

  const showNoWsWarning = (workspaces) => {
    const schedulerWithoutWs = workspaces.length === 0;
    return schedulerWithoutWs;
  };

  const onChangeStatus = (id, status, workspaces, type) => {
    const emptyWorkspaces = showNoWsWarning(workspaces);
    if (emptyWorkspaces) {
      dispatch(openModal(MODAL_SCHEDULER_NO_WS_WARNING));
    } else {
      dispatch(changeStatus(id, status, type));
    }
  };

  const run = (e, id, workspaces, isOnline, type, active) => {
    const emptyWorkspaces = showNoWsWarning(workspaces);
    const offlineAgent = type === 'agent' && !isOnline;
    if (emptyWorkspaces) {
      dispatch(openModal(MODAL_SCHEDULER_NO_WS_WARNING));
    } else if (offlineAgent) {
      dispatch(openModal(MODAL_SCHEDULER_OFFLINE_AGENT_WARNING));
    } else if (!active) {
      dispatch(openModal(MODAL_SCHEDULER_INACTIVE_WARNING));
    } else {
      dispatch(runSchedule(id, type));
      e.stopPropagation();
    }
  };

  const isSchedulerSelected = (rowInfo) => schedulersSelected.find((scheduler) => scheduler.id === rowInfo.original.id);

  const getThProps = (column, fields) => {
    const defaultMin = fields[column.id] ? fields[column.id].defaultWidth : 0;
    const maxWidth = fields[column.id] ? fields[column.id].maxWidth : 0;
    const response = { minWidth: defaultMin, maxWidth };
    return {
      style: defaultMin ? response : {}
    };
  };

  return (
    <TableWrapper>
      <SharedTable
        schema={ scheduledAgentsSchema }
        context={ { fields, onChangeStatus, isFetching, run } }
        data={ data }
        isLoading={ isFetching }
        onFetch={ fetchData }
        isRowSelected={ isSchedulerSelected }
        getHeaderProps={ (column) => getThProps(column, fields) }
        noDataText={ noDataText }
      />
      { error ? <ErrorDialog message={ errorMessage } resetError={ () => dispatch(clearError(section)) } /> : null }
    </TableWrapper>
  );
};

export default ScheduledAgents;
